import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer} from '@angular/forms';
import { Filter } from '../../../../models/filter.models';


@Component({
  selector: 'date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss']
})
export class DateRangeComponent implements OnInit {
  public dateFormGroup :any ;
  constructor(
    public controlContainer: ControlContainer
  ) {
  }

  @Input() data: Filter;

  ngOnInit(): void {
    this.dateFormGroup = this.controlContainer.control
  }

}
